var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.21 4.336)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.7,14.578H18.983l-.858-1.734V9.375h5.2v3.469l-.858,1.734H20.7Z",
    transform: "translate(-11.188 -0.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.6,11.8c2.87,0,6.937-1.734,6.937-4.336S25.853,3.125,20,3.125",
    transform: "translate(-10.462 -3.125)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 3.469,
    transform: "translate(19.077 4.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.062,11.8c-2.87,0-6.937-1.734-6.937-4.336s3.685-4.336,9.538-4.336",
    transform: "translate(-13.125 -3.125)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 3.469,
    transform: "translate(0 4.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20,5.627a18.782,18.782,0,0,1,6.278.91",
    transform: "translate(-10.462 -2.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.678,5.627a18.782,18.782,0,0,0-6.278.91",
    transform: "translate(-12.244 -2.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.875,13.086c2.87,0,6.937-1.734,6.937-4.336",
    transform: "translate(-9.735 -0.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.925,5.625h.1",
    transform: "translate(-10.491 -2.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.125,8.75c0,2.6,4.067,4.336,6.937,4.336",
    transform: "translate(-13.125 -0.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.743,13.125,23.469,41.74,20,46.076",
    transform: "translate(-10.462 0.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.188,13.125,17.463,41.74l3.469,4.336",
    transform: "translate(-11.445 0.749)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 56,
    height: 56
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTie);
export default __webpack_public_path__ + "static/media/Tie.e677887e12d5e1947536fbfc3ec2e16a.svg";
export { ForwardRef as ReactComponent };